import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../utils/api";
import { getDeviceUuid } from "../utils/deviceId";
import { setAuth } from "../actions";
import { PERMISSION } from "../utils/constants";
import { hasPermission } from "../utils/permissions";

class LoginPage extends Component {
  state = {
    email: "",
    password: "",
    loading: false,
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      return toast.error("Email and password are required");
    }

    this.setState({ loading: true });
    try {
      const loginRes = await API.post("/auth/login", {
        email,
        password,
        device_uuid: getDeviceUuid(),
        device_type: "web",
      });
      const { token: accessToken, refreshToken } =
        loginRes.data.data || loginRes.data;

      localStorage.setItem("teleAccessToken", accessToken);
      localStorage.setItem("teleRefreshToken", refreshToken);

      const meRes = await API.get("/auth/me");
      const me = meRes.data.data || meRes.data;
      const permissions = me.permissions || [];

      const authUser = {
        id: me.id,
        name: me.name,
        email: me.email,
        role: me.role,
        permissions,
      };

      localStorage.setItem("teleUser", JSON.stringify(authUser));
      localStorage.setItem("telePermissions", JSON.stringify(permissions));
      this.props.setAuth({ ...authUser, token: accessToken });
      toast.success("Login successful");
    } catch (err) {
      const msg =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Login failed";
      toast.error(msg);
    }
    this.setState({ loading: false });
  };

  render() {
    if (this.props.authenticated) {
      const { permissions } = this.props;
      const redirectTo = hasPermission(permissions, PERMISSION.REPORT_POSTED_ACCESS)
        ? "/admin/report/posted"
        : hasPermission(permissions, PERMISSION.MARKETING_SPEND_ACCESS)
        ? "/admin/marketing/spend"
        : "/leads";
      return <Redirect to={redirectTo} />;
    }

    const { email, password, loading } = this.state;

    return (
      <div className="login-wrapper">
        <div className="login-box">
          <h2>
            <i className="fas fa-phone-alt"></i> Tele Leads
          </h2>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={email}
                onChange={this.handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={this.handleChange}
                placeholder="Enter your password"
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? (
                <span>
                  <i className="fas fa-spinner fa-spin"></i> Logging in...
                </span>
              ) : (
                "Login"
              )}
            </button>
            <div className="text-center" style={{ marginTop: 12 }}>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authenticated: state.authenticated,
  permissions: state.permissions,
});

export default connect(mapStateToProps, { setAuth })(LoginPage);
